import { render, staticRenderFns } from "./Basico.vue?vue&type=template&id=f5d11110"
import script from "./Basico.vue?vue&type=script&lang=js"
export * from "./Basico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports